import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useState } from 'react';

import { InfoStyledDrawer } from './SmartChoice.styled';

export const InfoDrawerOrPopover = ({ mobileScreen, title, content }) => {
  const [openDrawerOrPopover, setOpenDrawerOrPopover] = useState(false);
  const handleClose = () => setOpenDrawerOrPopover(false);
  const handleOpen = () => setOpenDrawerOrPopover(true);
  if (mobileScreen) {
    return (
      <>
        <span
          onClick={handleOpen}
          style={{ cursor: 'pointer', display: 'inline-flex' }}
        >
          <IconSymbol
            color={'#196ECF'}
            icon="info"
            size={16.67}
            variant="outlined"
          />
        </span>
        <InfoStyledDrawer
          css={{
            '.abyss-modal-base-content-container': {
              '@media (max-width: 464px)': {
                height: 'auto !important',
                maxHeight: '70vh',
                overflowY: 'auto',
              },
            },
          }}
          header={
            <Text
              color="$core.color.neutral.100"
              css={{
                fontSize: '24px !important',
                fontWeight: 700,
                paddingTop: '0px',
              }}
              data-testid="smart-choice-preferences-heading"
            >
              {title}
            </Text>
          }
          isOpen={openDrawerOrPopover}
          onClose={handleClose}
          onOpenChange={(isOpen) => setOpenDrawerOrPopover(isOpen)}
          position={'right'}
          size={'sm'}
          title={title}
        >
          <div>{content}</div>
        </InfoStyledDrawer>
      </>
    );
  }
  return (
    <Popover
      content={content}
      onOpenChange={setOpenDrawerOrPopover}
      open={openDrawerOrPopover}
      position={'right'}
      title={title}
    >
      <span
        onClick={handleOpen}
        style={{ cursor: 'pointer', display: 'inline-flex' }}
      >
        <IconSymbol
          color={'#196ECF'}
          icon="info"
          size={16.67}
          variant="outlined"
        />
      </span>
    </Popover>
  );
};
